import featureFlagsConfig from './featureFlagConfig'
import { FeatureFlags } from './types'

/**
 * Returns the defaults for feature flags.
 * Can be used on the client side.
 */
export const getDefaultFeatureFlags = (): FeatureFlags =>
  Object.fromEntries(
    Object.entries(featureFlagsConfig).map(([key, value]) => [
      key,
      value.defaultValue,
    ]),
  ) as unknown as FeatureFlags

/**
 * Returns the feature flags from the server.
 * Can only be used on the server side
 */
export const getServerFeatureFlags = (): FeatureFlags => {
  if (!isServerOrJest()) {
    throw new Error('getServerFeatureFlags can only be used on the server side')
  }

  return Object.fromEntries(
    Object.entries(featureFlagsConfig).map(([key, value]) => [
      key,
      getFeatureFlagValueFromEnv(value),
    ]),
  ) as unknown as FeatureFlags
}

const getFeatureFlagValueFromEnv = ({
  env,
  defaultValue,
}: {
  env: string | undefined
  defaultValue: boolean
}) => {
  if (env === undefined) {
    return defaultValue
  }
  if (env === 'true' || env === '1' || env === 't') {
    return true
  }
  if (env === 'false' || env === '0' || env === 'f') {
    return false
  }
  throw new Error(`Invalid feature flag value: ${env}`)
}

const isServerOrJest = () => {
  const isRunningFromJest = !!process.env.JEST_WORKER_ID
  const isRunningOnServer = typeof window === 'undefined'
  return isRunningFromJest || isRunningOnServer
}
